import {
  Datagrid,
  EditButton,
  LongTextField,
  useFieldLabel,
} from "ra-friendsofbabba";
import {
  DateField,
  List as RaList,
  TextField,
  usePermissions,
} from "react-admin";
import React, { Fragment, useMemo } from "react";

import Actions from "../component/list/Actions";
import Empty from "../component/list/Empty";
import Filters from "./Filters";
import HelpBlock from "../component/HelpBlock";
import PeriodField from "./fields/PeriodField";
import PrintButton from "../component/button/PrintButton";
import { StateCollectionInput } from "ra-friendsofbabba";
import UserField from "../component/field/UserField";

const List = (props) => {
  const { loaded, permissions } = usePermissions();
  const { isAdmin, isTro } = useMemo(
    () => ({
      isAdmin: loaded && permissions(["admin"]),
      isTro: loaded && permissions(["tro"]),
    }),
    [loaded, permissions]
  );
  const additionalProps = isAdmin ? {} : { bulkActionButtons: false };
  const fieldLabel = useFieldLabel(props);
  return (
    <Fragment>
      <HelpBlock
        resource="intermediate-technical-report"
        context="list-admin"
        visibleFor={["admin"]}
      />
      <HelpBlock
        resource="intermediate-technical-report"
        context="list-researcher"
        visibleFor={["researcher"]}
      />

      <RaList
        {...props}
        {...additionalProps}
        empty={<Empty canCreate={isAdmin} />}
        actions={<Actions canExport={false} />}
        perPage={10}
        sort={{ field: "created", order: "DESC" }}
        filters={<Filters />}
      >
        <Datagrid rowClick="edit">
          {isAdmin && (
            <TextField source="id" label="ID" style={{ fontWeight: "bold" }} />
          )}
          <TextField
            source="executive_project.project_proposal.code"
            sortBy="ExecutiveProjects.ProjectProposals.code"
          />
          <PeriodField label="resources.intermediate-technical-reports.fields.period" />
          {(isAdmin || isTro) && (
            <UserField source="user.name" sortable={false} />
          )}
          {isTro && (
            <LongTextField
              source="executive_project.project_proposal.project_idea.university_department.name"
              label={fieldLabel("university_department.name")}
              sortable={false}
            />
          )}
          <LongTextField
            source="executive_project.project_proposal.name"
            sortBy="ExecutiveProjects.ProjectProposals.name"
          />

          <StateCollectionInput
            source="state"
            readonly={!isAdmin}
            admin={isAdmin}
          />
          <DateField source="modified" showTime />
          <PrintButton />
          <EditButton />
        </Datagrid>
      </RaList>
    </Fragment>
  );
};

export default List;
